export default __webpack_public_path__ + "static/media/words6.383ecf27.png";